<template>
  <div class="plan-pagos-datos">
    <b-row>
      <b-col cols="12" xl="12">
        <app-data
          titulo="Información del Plan de Pagos"
          :datos="planPagosDatos">
        </app-data>

        <b-card header="Detalle de Cuotas">
          <b-table 
              small 
              responsive="sm" 
              class="registro-ordenes"
              :items="planPagosCuotasDatos" 
              :fields="cuotasFields">
            <template v-slot:cell(fechaVencimiento)="data">
              {{ data.item.fechaVencimiento | fecha }}
            </template>
            <template v-slot:cell(importeCapital)="data">
              <span :class="{ 
                    'cuota-adeudada' : data.item.importeCapitalAdeudado,
                    'cuota-refinanciada': data.item.refinanciado
                  }">
                {{ data.item.importeCapital | moneda }}
              </span>  
            </template>
            <template v-slot:cell(importeIntereses)="data">
              <span :class="{ 
                    'cuota-adeudada' : data.item.importeInteresesAdeudado,
                    'cuota-refinanciada': data.item.refinanciado 
                  }">
                {{ data.item.importeIntereses | moneda }}
              </span>
            </template>
            <template v-slot:cell(importeInteresesResarcitorios)="data">
              <span :class="{ 
                    'cuota-adeudada' : data.item.importeInteresesResarcitoriosAdeudado,
                    'cuota-refinanciada': data.item.refinanciado 
                  }">
                {{ data.item.importeInteresesResarcitorios | moneda }}
              </span>
            </template>
          </b-table>
        </b-card>

        <app-data
          v-if="planPagosPagoDatos"
          titulo="Información del Pago"
          :datos="planPagosPagoDatos">
        </app-data>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="data-goback-btn" @click.prevent="goList">
          <i class="fa fa-undo fa-2x" aria-hidden="true"></i>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Data from  '../shared/tableData.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'planPagos/getField',
  mutationType: 'planPagos/updateField',
});

export default {
  name: 'PlanPagosDatos',
  components: {
    appData: Data,
    appMensaje: Mensaje,
  },
  mixins: [
    msjModal, 
  ],
  data: () => {
    return {
      planPagosId: 0,

      itemFields: [
        {key: 'campo'},
        {key: 'valor'},
      ],
      cuotasFields: [
        {
          key: 'numeroCuota',
          label: 'Nro Cuota'
        },
        {
          key: 'fechaVencimiento'
        },
        {
          key: 'importeCapital',
          label: 'Capital',
          class: 'text-right'
        },
        {
          key: 'importeIntereses',
          label: 'Intereses',
          class: 'text-right'
        },
        {
          key: 'importeInteresesResarcitorios',
          label: 'Intereses Resarcit.',
          class: 'text-right'
        },

      ],
    }
  },
  computed: {
    ...mapFields([
      'planPagosDatos',
      'planPagosCuotasDatos',
      'planPagosPagoDatos',
    ]),
  },
  created() {
    this.planPagosId = this.$route.params.id;

    this.showSpinner();
    this.$store.dispatch('planPagos/getPlanPagosDatos', this.planPagosId)
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());
  },  
  methods: {
    goList() {
      this.$router.push({ name: 'PlanesPagos' });
    },
  }
}
</script>

<style>
  .plan-pagos-datos .registro-ordenes tr td span.cuota-adeudada,
  .plan-pagos-datos .registro-ordenes tr td span.cuota-refinanciada {
    background-color: transparent;
    border-color: #c8ced3;
    color: var(--danger);
  }
  .plan-pagos-datos .registro-ordenes tr td span.cuota-adeudada {
    color: var(--danger);
  }
  .plan-pagos-datos .registro-ordenes tr td span.cuota-refinanciada {
    color: blue;
  }
</style>